import {
  GET_AUDIT_SUPPLIERS_REQUEST,
  GET_AUDIT_SUPPLIERS_SUCCESS,
  GET_AUDIT_SUPPLIERS_ERROR,
} from './supplierActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  message: '',
  suppliers: [],
  auditSuppliers: [],
  pagination: {},
};

export default function supplierReducer(state = initialState, action) {
  const { type, payload, isLoading, message } = action;

  switch (type) {
    case GET_AUDIT_SUPPLIERS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_SUPPLIERS_SUCCESS:
      return { ...state, isLoading, auditSuppliers: payload.data };
    case GET_AUDIT_SUPPLIERS_ERROR:
      return { ...state, isLoading, message };
    default: {
      return state;
    }
  }
}
